import axios from "@/api/index";
let method = 'GET';
/*职位分类三级列表*/
export const jobThreeClassification=data=>axios.get('/home/rest/RevisionOnePersonalCenter/jobThreeClassification',data)
/*招聘--期望薪资/薪资范围*/
export const yqzdExpectedSalary=data=>axios.get('/versions/cloudOfficialWebsitePC/yqzdExpectedSalary',data)
/*招聘--搜索列表*/
export const yqzdJobSearchList=data=>axios.post('/versions/cloudOfficialWebsitePC/yqzdJobSearchList',data)
/*经营工具--招聘详情*/
export const homepageRecruitmentDetails=data=>axios.post('/versions/cloudOfficialWebsitePC/homepageRecruitmentDetails',data)